
interface Category {
  id: string;
  label: string;
  icon: string;
  count: number;
}

interface FAQCategoriesProps {
  categories: Category[];
  activeCategory: string;
  onSelect: (id: string) => void;
}

const FAQCategories = ({ categories, activeCategory, onSelect }: FAQCategoriesProps) => {
  return (
    <div className="flex flex-wrap gap-3 justify-center">
      {categories.map((cat) => (
        <button
          key={cat.id}
          onClick={() => onSelect(cat.id)}
          className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap border ${
            activeCategory === cat.id
              ? 'bg-slate-900 text-white border-slate-900 shadow-md'
              : 'bg-white text-slate-600 border-slate-200 hover:border-slate-400 hover:text-slate-800'
          }`}
        >
          <i className={`${cat.icon} text-base`}></i>
          {cat.label}
          <span
            className={`text-xs px-1.5 py-0.5 rounded-full font-semibold ${
              activeCategory === cat.id ? 'bg-white/20 text-white' : 'bg-slate-100 text-slate-500'
            }`}
          >
            {cat.count}
          </span>
        </button>
      ))}
    </div>
  );
};

export default FAQCategories;
